import React from "react";
import Select from "react-select";
import DropDownStyles, { selectMenuPortalProps } from "./dropdownStyles.js";

const PageSizeDropDownSelection = ({ defaultValue, onChange }) => {
  const pageSizeOptions = [
    { value: "20", label: "20" },
    { value: "50", label: "50" },
    { value: "100", label: "100" },
  ];

  return (
    <Select
      defaultValue={defaultValue}
      onChange={onChange}
      options={pageSizeOptions}
      styles={DropDownStyles}
      {...selectMenuPortalProps}
      placeholder={"Page Size"}
    />
  );
};

export default PageSizeDropDownSelection;

export const SortOrderDropDownSelection = ({ defaultValue, onChange }) => {
  const sortOrderOptions = [
    { value: "DESC", label: "Desc" },
    { value: "ASC", label: "Asc" },
  ];

  return (
    <Select
      defaultValue={defaultValue}
      onChange={onChange}
      options={sortOrderOptions}
      styles={DropDownStyles}
      {...selectMenuPortalProps}
      placeholder={"Sort Order"}
    />
  );
};
export const LengthUnitDropDownSelection = ({
  defaultValue,
  onChange,
  selectedValue,
}) => {
  const LengthUnitOptions = [
    { value: "mm", label: "MilliMeter" },
    { value: "inches", label: "Inches" },
  ];

  return (
    <Select
      defaultValue={defaultValue}
      value={LengthUnitOptions.find((option) => option.value === selectedValue)}
      onChange={onChange}
      options={LengthUnitOptions}
      styles={DropDownStyles}
      {...selectMenuPortalProps}
      placeholder="Select Length Unit"
      isClearable={true}
    />
  );
};

export const ForageDropDownSelection = ({
  defaultValue,
  onChange,
  selectedValue,
  allowMultiple,
}) => {
  const ForageOptions = [
    { value: "Threadfin Shad", label: "Threadfin Shad" },
    { value: "Fathead Minnows", label: "Fathead Minnows" },
    { value: "Golden Shiner", label: "Golden Shiner" },
    { value: "Tilapia", label: "Tilapia" },
    { value: "Bluegill", label: "Bluegill" },
    { value: "Gizzard Shad", label: "Gizzard Shad" },
    { value: "Crawdads", label: "Crawdads" },
    { value: "Red Ear Sunfish", label: "Red Ear Sunfish" },
    { value: "Green Sunfish", label: "Green Sunfish" },
    { value: "Goldfish", label: "Goldfish" },
    { value: "Trout", label: "Trout" },
  ];

  // Function to get the selected options for display
  const getSelectedOptions = () => {
    if (allowMultiple) {
      // If selectedValue is an array of values, map them to option objects
      if (Array.isArray(selectedValue)) {
        return ForageOptions.filter((option) =>
          selectedValue.includes(option.value)
        );
      }
      // If selectedValue is a comma-separated string, split and map
      if (typeof selectedValue === "string" && selectedValue) {
        const values = selectedValue.split(",");
        return ForageOptions.filter((option) => values.includes(option.value));
      }
      return [];
    } else {
      // Single selection
      return (
        ForageOptions.find((option) => option.value === selectedValue) || null
      );
    }
  };

  return (
    <Select
      defaultValue={defaultValue}
      value={getSelectedOptions()}
      onChange={onChange}
      options={ForageOptions}
      styles={DropDownStyles}
      {...selectMenuPortalProps}
      isMulti={allowMultiple}
      placeholder="Select Forage"
      isClearable={true}
      closeMenuOnSelect={!allowMultiple}
    />
  );
};

export const TypeDropDownSelection = ({
  defaultValue,
  onChange,
  selectedValue,
  hideLabel = false,
}) => {
  const LengthUnitOptions = [
    { value: "Natural", label: "Natural" },
    { value: "Manmade", label: "Manmade" },
  ];

  return (
    <div className="donezo-pond-type-field">
      {!hideLabel && (
        <label className="form-label small mb-1" htmlFor="pond-type-select">
          Pond Type <span className="text-danger">*</span>
        </label>
      )}
      <Select
        inputId="pond-type-select"
        defaultValue={defaultValue}
        value={LengthUnitOptions.find((option) => option.value === selectedValue)}
        onChange={onChange}
        options={LengthUnitOptions}
        styles={DropDownStyles}
        {...selectMenuPortalProps}
        placeholder="Select Pond Type"
        isClearable={true}
        classNamePrefix="pond-type-select"
      />
    </div>
  );
};

export const WaterSupplyDropDownSelection = ({
  defaultValue,
  onChange,
  selectedValue,
  allowMultiple = false, // Add this prop to enable multi-selection
  hideLabel = false,
}) => {
  const WaterSupplyOptions = [
    { value: "Stream/Creek", label: "Stream/Creek" },
    { value: "Rain/Runoff", label: "Rain/Runoff" },
    { value: "Spring", label: "Spring" },
  ];

  // Handle single vs multiple selection display
  const getSelectedOptions = () => {
    if (!selectedValue) return null;

    if (allowMultiple) {
      // For multi-selection, selectedValue should be an array
      return Array.isArray(selectedValue)
        ? WaterSupplyOptions.filter((option) =>
          selectedValue.includes(option.value)
        )
        : [];
    } else {
      // For single selection, selectedValue should be a string
      return WaterSupplyOptions.find(
        (option) => option.value === selectedValue
      );
    }
  };

  return (
    <div className="donezo-pond-type-field">
      {!hideLabel && (
        <label className="form-label small mb-1" htmlFor="water-supply-select">
          Water Supply
        </label>
      )}
      <Select
        inputId="water-supply-select"
        defaultValue={defaultValue}
        value={getSelectedOptions()}
        onChange={onChange}
        options={WaterSupplyOptions}
        styles={DropDownStyles}
        {...selectMenuPortalProps}
        placeholder="Select Water Supply"
        isClearable={true}
        isMulti={allowMultiple} // Enable multi-selection based on prop
      />
    </div>
  );
};
